import React, { useMemo } from 'react';
import CpanelAsideToggle from './CpanelAsideToggle';
import CpanelBreadcrumb from './CpanelBreadcrumb';

const CpanelPageShell = ({
  title,
  subtitle = 'CPanel Center Administrasi',
  children,
  actions,
  breadcrumbs,
}) => {
  const trail = useMemo(() => {
    if (breadcrumbs?.length) return breadcrumbs;
    return [
      { label: 'CPanel Center', to: '/cpanel/dashboard' },
      { label: title },
    ];
  }, [breadcrumbs, title]);

  return (
    <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
      <div className="toolbar" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid cpanel-toolbar-container">
          <div className="cpanel-toolbar-row w-100">
            <div className="cpanel-toolbar-main flex-grow-1 min-w-0">
              <div className="cpanel-toolbar-head cpanel-toolbar-head--grid w-100">
                <CpanelBreadcrumb items={trail} />
                <div className="cpanel-toolbar-leading d-none d-lg-flex align-items-center justify-content-center flex-shrink-0">
                  <CpanelAsideToggle />
                </div>
                <div className="cpanel-toolbar-title-body page-title cpanel-page-title-wrap d-flex flex-column mb-0 min-w-0">
                  <h1 className="cpanel-page-title text-dark fw-bolder fs-3 my-1 mb-0">{title}</h1>
                  {subtitle ? (
                    <p className="cpanel-page-title__subtitle text-muted fs-7 fw-semibold mb-0">{subtitle}</p>
                  ) : null}
                </div>
              </div>
              {actions ? (
                <div className="cpanel-toolbar-actions d-flex align-items-center">{actions}</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" className="container-xxl">
          {children != null ? (
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">{children}</div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CpanelPageShell;
